import { INomWebServicesJson } from "@common/interfaces/i-nom-web-services-json";
import { IGlobalTablesService } from "@common/interfaces/i-global-tables-service";
import { DateTime } from '@common/data-models/complex-types/date-time';
import moment from 'moment-timezone';

export class FilterKeywords {
    public static globalTablesService: IGlobalTablesService;
    public static nomWebServicesJson: INomWebServicesJson;

    public static getValue(keyword: any): any {
        let fromDate: Date = null;
        let toDate: Date = null;

        if (typeof keyword === "string") {
            if (keyword.startsWith("@")) {
                if (keyword == "@staff_id_me") {
                    return FilterKeywords.nomWebServicesJson.UserId;
                } else if (keyword.startsWith("@date_range_")) {
                    let id: string = keyword.replace("@date_range_", "").replace(/_/g, "").toUpperCase();
                    let value: string = null;
                    if (FilterKeywords.globalTablesService.CustomFilterDefsDict[id]) {
                        if (FilterKeywords.globalTablesService.CustomFilterDefsDict[id].Validation == "DATE"
                            || FilterKeywords.globalTablesService.CustomFilterDefsDict[id].Validation == "TIME"
                            || FilterKeywords.globalTablesService.CustomFilterDefsDict[id].Validation == "MOSDATETIME"
                        ) {
                            value = FilterKeywords.globalTablesService.CustomFilterDefsDict[id].Value;
                        }
                    }
                    if (value) {
                        let currentMomentObjFrom = FilterKeywords.getCurrentMomentObj();
                        let currentMomentObjTo = FilterKeywords.getCurrentMomentObj();

                        if (value == "all") {
                            return null;
                        } else if (value == "blank") {
                            fromDate = moment('1800-01-01').startOf('day').toDate();
                            toDate = moment('1800-01-01').endOf('day').subtract(1, 'second').toDate();
                            return [fromDate, toDate];
                        } else if (value == "tomorrow") {
                            fromDate = currentMomentObjFrom.add(1, 'days').startOf('day').toDate();
                            toDate = currentMomentObjTo.add(1, 'days').endOf('day').subtract(1, 'second').toDate();
                        } else if (value == "today") {
                            fromDate = currentMomentObjFrom.startOf('day').toDate();
                            toDate = currentMomentObjTo.add(1, 'day').startOf('day').subtract(1, 'second').toDate();
                        } else if (value == "thisweek") {
                            fromDate = currentMomentObjFrom.startOf('isoWeek').add(this.nomWebServicesJson.HelloResults.DayOfWeek, 'days').subtract(1, 'day').toDate();
                            toDate = currentMomentObjTo.endOf('isoWeek').add(this.nomWebServicesJson.HelloResults.DayOfWeek, 'days').subtract(1, 'day').toDate();
                        } else if (value == "nextweek") {
                            fromDate = currentMomentObjFrom.add(1, 'weeks').startOf('isoWeek').add(this.nomWebServicesJson.HelloResults.DayOfWeek, 'days').subtract(1, 'day').toDate();
                            toDate = currentMomentObjTo.add(1, 'weeks').endOf('isoWeek').add(this.nomWebServicesJson.HelloResults.DayOfWeek, 'days').subtract(1, 'day').toDate();
                        } else if (value == "weekafternext") {
                            fromDate = currentMomentObjFrom.add(2, 'weeks').startOf('isoWeek').add(this.nomWebServicesJson.HelloResults.DayOfWeek, 'days').subtract(1, 'day').toDate();
                            toDate = currentMomentObjTo.add(2, 'weeks').endOf('isoWeek').add(this.nomWebServicesJson.HelloResults.DayOfWeek, 'days').subtract(1, 'day').toDate();
                        } else if (value == "future") {
                            fromDate = currentMomentObjFrom.startOf('day').toDate();
                            toDate = currentMomentObjTo.add(1000, 'years').toDate();
                        } else {
                            // CUSTOM, USER-DEFINED (from System Maintenance)
                            // we need to parse the fval to see if it falls into any of the allowed formats:
                            // for example:
                            // Today +/- 5 => lastnext 5 day
                            // Today + 5 => next 5 day
                            // Today + 7 => next 7 day
                            // Next 12 Hours => next 12 hour
                            // Last 6 Months => last 6 month
                            // This Hour => this hour
                            // This Year => this year
                            let fparts: Array<string> = value.split(" ");
                            if (fparts.length == 2 && fparts[0] == "this") {
                                if (fparts[1] == "hour" || fparts[1] == "day" || fparts[1] == "month" || fparts[1] == "week" || fparts[1] == "year") {
                                    if (fparts[1] == 'week') {
                                        fparts[1] = 'isoWeek';
                                    }
                                    fromDate = currentMomentObjFrom.startOf(fparts[1]).toDate();
                                    toDate = currentMomentObjTo.endOf(fparts[1]).toDate();
                                } else {
                                    return undefined; // unrecognized
                                }
                            } else if (fparts.length == 3 && (fparts[0] == "last" || fparts[0] == "next" || fparts[0] == "lastnext")) {
                                if (fparts[0] == "last") {
                                    fromDate = FilterKeywords.getLastFromDate(fparts[2], fparts[1]);
                                    toDate = FilterKeywords.getStartOfDate(fparts[2]);
                                } else if (fparts[0] == "next") {
                                    fromDate = FilterKeywords.getStartOfDate(fparts[2]);
                                    toDate = FilterKeywords.getNextToDate(fparts[2], fparts[1]);
                                } else { // "lastnext"
                                    fromDate = FilterKeywords.getLastFromDate(fparts[2], fparts[1]);
                                    toDate = FilterKeywords.getNextToDate(fparts[2], fparts[1]);
                                }
                            } else {
                                return undefined; // unrecognized format for filter value. 
                            }
                        }
                    } else {
                        return undefined;
                    }
                } else {
                    return undefined;
                }

                return [fromDate, toDate];
            }
            return undefined;
        }
        return undefined;
    }

    private static getCurrentMomentObj() : any {
        let currentDateTime = new Date();
        if (FilterKeywords.globalTablesService.PersonalTimeZone) {
            if (FilterKeywords.globalTablesService.ClientTimeZone) {
                if (FilterKeywords.globalTablesService.PersonalTimeZone.id !== FilterKeywords.globalTablesService.ClientTimeZone.id) {
                    currentDateTime = DateTime.convertToTargetTZ(currentDateTime, FilterKeywords.globalTablesService.PersonalTimeZone.id, FilterKeywords.globalTablesService.ClientTimeZone.id);
                }
            }
        }
        let currentMomentObj = moment(currentDateTime);
        return currentMomentObj;
    }

    private static getNextToDate(unit: string, value: string): Date {
        let currentMomentObj = FilterKeywords.getCurrentMomentObj();
        if (unit == "hour") {
            return currentMomentObj.add(parseInt(value), unit).toDate();
        }
        return currentMomentObj.endOf(unit).add(parseInt(value), unit).toDate();
    }

    private static getLastFromDate(unit: string, value: string): Date {
        let currentMomentObj = FilterKeywords.getCurrentMomentObj();
        if (unit == "hour") {
            return currentMomentObj.subtract(parseInt(value), unit).toDate();
        }
        return currentMomentObj.startOf(unit).subtract(parseInt(value), unit).toDate();
    }

    private static getStartOfDate(unit: string): Date {
        let currentMomentObj = FilterKeywords.getCurrentMomentObj();
        if (unit == "hour") {
            return currentMomentObj.toDate();
        }
        return currentMomentObj.startOf(unit).toDate();
    }
}
